<template>
	<div class="attend-card-wrapper d-flex align-center px-8 py-6 mb-2">
		<Avatar
			class="mr-8 post-preview-card__avatar"
			ize="85"
			:avatar="speaker.speaker_logo"
		/>
		<div>
			<div
				v-if='speaker.speaker_name'
				class="attend-card-title mb-2"
			>
				{{ speaker.speaker_name }}
			</div>
			<div
				v-if='speaker.speaker_title'
				class="attend-card-location mb-2"
			>
				{{ speaker.speaker_title }}
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar.vue'

Vue.use(VueScrollTo)

export default {
	name: 'SpeakerCard',
	components: { 
		Avatar 
	},
	props: {
		speaker: {
			type: Object,
			default: () => {},
		},
	},
}
</script>

<style lang="scss">
.attend-card {
	&-location {
		color: var(--company-position-large) !important;
	}
}
</style>
